export default "__VITE_ASSET__CWmQjSdi__"